var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-snackbar',{attrs:{"timeout":_vm.timeout,"color":_vm.color,"bottom":!_vm.top,"top":_vm.top,"outlined":"","text":""},model:{value:(_vm.active),callback:function ($$v) {_vm.active=$$v},expression:"active"}},[_vm._v(" "+_vm._s(_vm.text.message || _vm.text)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }